export const userSVG = `<svg
                class="flex-shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                width="42"
                height="42"
                viewBox="0 0 42 42"
              >
                <g fill="none" fill-rule="evenodd">
                  <circle
                    cx="21"
                    cy="21"
                    r="21"
                    fill="#54CEF9"
                    opacity=".2"
                  ></circle>
                  <g fill-rule="nonzero">
                    <path
                      fill="#54CEF9"
                      d="M9.189 11.738c2.668 0 4.831-2.628 4.831-5.87C14.02 2.629 13.31 0 9.19 0 5.067 0 4.357 2.628 4.357 5.869c0 3.241 2.163 5.869 4.832 5.869z"
                      transform="translate(12 9)"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M.104 20.747c-.002-.292-.004-.082 0 0zM18.354 20.853c.006-.054.002-.376 0 0z"
                      transform="translate(12 9)"
                    ></path>
                    <path
                      fill="#54CEF9"
                      d="M18.304 20.462c-.09-5.647-.827-7.256-6.47-8.274 0 0-.794 1.012-2.645 1.012-1.852 0-2.646-1.012-2.646-1.012C.96 13.195.179 14.78.076 20.278c-.008.449-.012.473-.014.42l.001.594S1.406 24 9.189 24c7.781 0 9.125-2.708 9.125-2.708v-.44c-.001.033-.004-.03-.01-.39z"
                      transform="translate(12 9)"
                    ></path>
                  </g>
                </g>
              </svg>`;
